import { Vue, Component, Prop } from 'vue-property-decorator';
import {
  BButton,
  BModal,
  BForm,
  BFormInput,
  BFormGroup,
  BImg,
  BFormSelect,
  BInputGroup,
  BInputGroupPrepend
} from 'bootstrap-vue';
import {
  ValidationProvider,
  ValidationObserver
} from 'vee-validate/dist/vee-validate.full';
import CustomLabel from '@/@core/components/labels/CustomLabel.vue';
import { QuotationType, UpdateSizeThresholdInput } from '@/api/api';
import ApiClientFactory from '@/api/apiClientFactory';

@Component({
  components: {
    BFormGroup,
    BFormInput,
    BButton,
    BModal,
    BForm,
    BImg,
    ValidationProvider,
    ValidationObserver,
    CustomLabel,
    BFormSelect,
    BInputGroup,
    BInputGroupPrepend
  }
})
export default class InkjetThresholdFormModal extends Vue {
  $refs!: {
    formRules: InstanceType<typeof ValidationProvider>;
    modal: InstanceType<typeof BModal>;
  };
  sign?: number = 1;
  area?: string = undefined;
  index?: number = 0;

  @Prop({ required: true })
  areas!: number[];

  signOptions = [
    {
      item: 1,
      name: 'Trên'
    },
    {
      item: -1,
      name: 'Dưới'
    }
  ];

  openCreateModal(): void {
    this.area = undefined;
    this.index = undefined;
    this.$refs.modal.show();
  }

  openEditModal(area: number, index: number): void {
    this.area = area.toString();
    this.index = index;
    this.$refs.modal.show();
  }

  submit(): void {
    this.$refs.formRules.validate().then(async (success) => {
      const area = Number(this.area);
      if (isNaN(area) || area === 0) {
        this.$refs.formRules.setErrors({ area: ['Giá trị không hợp lệ'] });
        return;
      }
      if (this.areas.includes(area)) {
        this.$refs.formRules.setErrors({ area: ['Diện tích đã tồn tại'] });
        return;
      }
      if (success) {
        const newThreshold = {
          width: area * (this.sign ?? 1),
          height: area * (this.sign ?? 1),
          originalValue: {
            width: 0,
            height: 0
          } as UpdateSizeThresholdInput,
          quotationType: QuotationType.InkjetPrinting
        } as UpdateSizeThresholdInput;

        try {
          const client = new ApiClientFactory().priceClient();
          const result = await client.updateSizeThresholdByCategories(
            newThreshold
          );

          if (!result || result != true) {
            this.$bvToast.toast(
              'Thêm diện tích thất bại, vui lòng thử lại sau',
              {
                title: 'Thay Đổi Khoảng Giá',
                toaster: 'b-toaster-bottom-right',
                variant: 'danger'
              }
            );

            return;
          }

          this.$bvToast.toast('Chỉnh sửa thành công', {
            title: 'Thay Đổi Khoảng Giá',
            toaster: 'b-toaster-bottom-right',
            variant: 'success'
          });
          this.$emit('onClose', this.area, this.index);
          this.$refs.modal.hide();
        } catch (err) {
          this.$bvToast.toast('Thêm diện tích thất bại, vui lòng thử lại sau', {
            title: 'Thay Đổi Khoảng Giá',
            toaster: 'b-toaster-bottom-right',
            variant: 'danger'
          });
          console.log(err);
        }
      }
    });
  }
}
